// extracted by mini-css-extract-plugin
export default {"news_box":"index_news_box_e0RBP clearfix","box_r":"index_box_r_6jcbY","d_box":"index_d_box_NAQAE"};